import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../Images";
import { Link, useLocation } from "react-router-dom";
import NavFloatingMenu from "./NavFloatingMenu";
import ReportTypeModel from "./Reports/ReportTypeModel";
import DownloadModel from "./DownloadModel";
import ContactDetailsModal from "./ContactDetailModel";
import { useDispatch, useSelector } from "react-redux";
import { Remove_User } from "../Redux/actions";
import { GoGlobe } from "react-icons/go";
import { useTranslation } from "react-i18next";
import { FaQuestionCircle } from "react-icons/fa";

const Navbar = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const isAdmin = user?.userType == 1 ? "ADMIN" : "CUSTOMER";
  const [isNavActive, setIsNavActive] = useState(false);
  const [isUserMenuVisible, setIsUserMenuVisible] = useState(false);
  const [openReportTypeModel, setOpenReportTypeModel] = useState(false);
  const [openDownloadModel, setOpenDownloadModel] = useState(false);
  const [openContactModel, setOpenContactModel] = useState(false);
  const [isMobileUser, setIsMobileUser] = useState(false);
  const { pathname } = useLocation();
  const [showHelpPopup, setShowHelpPopup] = useState(false);

  const dispatch = useDispatch();

  const logout = () => dispatch(Remove_User());
  //console.log("user", user);
  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    setIsMobileUser(isMobile);
  }, [window.innerWidth]);

  useEffect(() => {
    setIsNavActive(false);
  }, [pathname]);

  const toggleNavbar = () => setIsNavActive(!isNavActive);

  return (
    <>
      {openReportTypeModel && (
        <ReportTypeModel
          setOpenReportTypeModel={setOpenReportTypeModel}
          // selectedItem={selectedItem}
          // paymentApiData={paymentApiData}
        />
      )}

      {openDownloadModel && (
        <DownloadModel
          setOpenDownloadModel={setOpenDownloadModel}
          // selectedItem={selectedItem}
          // paymentApiData={paymentApiData}
        />
      )}

      {openContactModel && (
        <ContactDetailsModal setOpenContactModel={setOpenContactModel} />
      )}

      <Nav>
        <Container $isNavActive={isNavActive}>
          <Link to="/" className="z-10">
            {/* <Logo src={Images.Logo} alt="NSC Online Registration System - SARS" /> */}
            <div className="flex space-x-2 mt-2">
              <Logo src={Images.GovtLogo} alt="logo" />
              <VerticalBorder />
              <Logo src={Images.Logo} alt="logo" />
            </div>
          </Link>
          <MenuIconComp toggleNavbar={toggleNavbar} />
          <NavLinksComp
            isAdmin={isAdmin}
            isNavActive={isNavActive}
            isUserMenuVisible={isUserMenuVisible}
            setIsUserMenuVisible={setIsUserMenuVisible}
            isMobileUser={isMobileUser}
            logout={logout}
            user={user}
            pathname={pathname}
            setOpenReportTypeModel={setOpenReportTypeModel}
            setOpenDownloadModel={setOpenDownloadModel}
            setOpenContactModel={setOpenContactModel}
            setShowHelpPopup={setShowHelpPopup}
            showHelpPopup={showHelpPopup}
          />
        </Container>
      </Nav>
    </>
  );
};

const NavLinksComp = ({
  isAdmin,
  isNavActive,
  setIsUserMenuVisible,
  isUserMenuVisible,
  isMobileUser,
  logout,
  user,
  pathname,
  setOpenReportTypeModel,
  setOpenDownloadModel,
  setOpenContactModel,
  setShowHelpPopup,
  showHelpPopup,
}) => {
  const [showBookingSubLinks, setShowBookingSubLinks] = useState(false);
  const [showBookingSubLinks2, setShowBookingSubLinks2] = useState(false);
  const { t, i18n } = useTranslation();

  return (
    <NavLinksWrapper $isNavActive={isNavActive}>
      <Link to="/dashboard">
        <NavLink $active={pathname === "/dashboard"}>
          <p>{t("Dashboard")}</p>
        </NavLink>
      </Link>
      {(user?.userType == 1 || user?.userType == 9) && (
        <>
          <Link to="/admin/users">
            <NavLink $active={pathname === "/admin/users"}>
              <p>{t("Users")}</p>
            </NavLink>
          </Link>
          <Link to="/admin/registrars">
            <NavLink $active={pathname === "/admin/registrars"}>
              <p>{t("Regional_Registrars")}</p>
            </NavLink>
          </Link>
          <Link to="/admin/asttregistrars">
            <NavLink $active={pathname === "/admin/asttregistrars"}>
              <p>{t("Astt_Registrars")}</p>
            </NavLink>
          </Link>
          <Link to="/admin/finance">
            <NavLink $active={pathname === "/admin/finance"}>
              <p>{t("Finance")}</p>
            </NavLink>
          </Link>
          <Link to="/admin/customers">
            <NavLink $active={pathname === "/admin/customers"}>
              <p>{t("Customers")}</p>
            </NavLink>
          </Link>
        </>
      )}
      {user?.userType == 2 && (
        <>
          <Link to="/payments">
            <NavLink $active={pathname === "/payments"}>
              <p>{t("Payments")}</p>
            </NavLink>
          </Link>
          <Link to="/admin/customers">
            <NavLink $active={pathname === "/admin/customers"}>
              <p>{t("Customers")}</p>
            </NavLink>
          </Link>
        </>
      )}
      {(user?.userType == 3 || user?.userType == 8) && (
        <>
          <Link to="/applications">
            <NavLink $active={pathname === "/applications"}>
              <p>{t("Applications")}</p>
            </NavLink>
          </Link>
          <Link to="/admin/customers">
            <NavLink $active={pathname === "/admin/customers"}>
              <p>{t("Customers")}</p>
            </NavLink>
          </Link>
          <Link to="/registered-assocs">
            <NavLink $active={pathname === "/registered-assocs"}>
              <p>{t("Registered_Associations")}</p>
            </NavLink>
          </Link>
          <Link to="" onClick={() => setOpenReportTypeModel(true)}>
            <NavLink $active={pathname === "/report/associations"}>
              <p>{t("Reports")}</p>
            </NavLink>
          </Link>
          {/* <Link to="/report-P">
          <NavLink $active={pathname === "/report-P"}>
            <p>Reports-P</p>
          </NavLink>
        </Link>
        <Link to="/report-AF">
          <NavLink $active={pathname === "/report-AF"}>
            <p>Reports-AF</p>
          </NavLink>
        </Link> */}
        </>
      )}
      {(user?.userType == 4 || user?.userType == 7) && (
        <>
          <Link to="/applications">
            <NavLink $active={pathname === "/applications"}>
              <p>{t("Applications")}</p>
            </NavLink>
          </Link>
          <Link to="/registered-assocs">
            <NavLink $active={pathname === "/registered-assocs"}>
              <p>{t("Registered_Associations")}</p>
            </NavLink>
          </Link>
          {/* <Link to="/admin/customers">
          <NavLink $active={pathname === "/admin/customers"}>
            <p>Customers</p>
          </NavLink>
        </Link> */}
        </>
      )}
      {user?.userType == 5 && (
        <>
          <Link to="/my-association">
            <NavLink $active={pathname === "/my-association"}>
              <p>{t("My_Associations")}</p>
            </NavLink>
          </Link>
          <Link to="/my-applications">
            <NavLink $active={pathname === "/my-applications"}>
              <p>{t("My_Requests")}</p>
            </NavLink>
          </Link>
          <Link to="" onClick={() => setOpenDownloadModel(true)}>
            <NavLink $active={pathname === "/guidelines"}>
              <p>{t("Download_Samples")}</p>
            </NavLink>
          </Link>
          {/* <Link to="/new-requests">
          <NavLink $active={pathname === "/new-requests"}>
            <p>New Requests</p>
          </NavLink>
        </Link> */}
        </>
      )}
      {user?.userType == 5 && (
        <Link to="" onClick={() => setOpenContactModel(true)}>
          <NavLink $active={pathname === "/contact"}>
            <p>
              <FaQuestionCircle />
            </p>
          </NavLink>
        </Link>
      )}
      {/* <NavLink
        className="relative sm:hover:bg-white sm:px-0"
        onMouseEnter={() => setShowBookingSubLinks2(true)}
        onMouseLeave={() => setShowBookingSubLinks2(false)}
        onClick={() => setShowBookingSubLinks2(!showBookingSubLinks2)}
      >
        <NavLink
          $active={pathname.includes("/campaigns")}
          className={showBookingSubLinks2 ? "bg-gray-100" : ""}
        >
          New Requests
        </NavLink>

        {showBookingSubLinks2 && (
          <SubLinksWrapper2>
            <Link
              to="/"
              className="text-black hover:bg-gray-100 px-4 py-2 rounded-full"
            >
              Registration
            </Link>
            <Link
              to="/"
              className="text-black hover:bg-gray-100 px-4 py-2 rounded-full"
            >
              Others
            </Link>
          </SubLinksWrapper2>
        )}
      </NavLink> */}

      {/* <Link to="/reports">
        <NavLink $active={pathname.includes("/reports")}>
          <p>Reports</p>
        </NavLink>
      </Link> */}

      {!isMobileUser && (
        <DesktopMenu
          setIsUserMenuVisible={setIsUserMenuVisible}
          isUserMenuVisible={isUserMenuVisible}
          logout={logout}
          user={user}
        />
      )}

      {isMobileUser && <MobileMenu logout={logout} user={user} />}
    </NavLinksWrapper>
  );
};

const DesktopMenu = ({
  setIsUserMenuVisible,
  isUserMenuVisible,
  logout,
  user,
}) => (
  <NavLink
    $last={true}
    className="md:h-full md:h-16 md:bg-white hover:bg-white "
    onMouseEnter={() => setIsUserMenuVisible(true)}
    onMouseLeave={() => setIsUserMenuVisible(false)}
    onClick={() => setIsUserMenuVisible(!isUserMenuVisible)}
  >
    <UserImage src={user?.userImage || Images.NurseImage} alt="nurse image" />
    <p className="md:hidden">My Profile</p>
    {isUserMenuVisible && (
      <NavFloatingMenu
        setIsUserMenuVisible={setIsUserMenuVisible}
        logout={logout}
      />
    )}
  </NavLink>
);

const MobileMenu = ({ logout, user }) => (
  <>
    <Link to="/my-profile" className="h-full">
      <NavLink title="My Profile">
        <UserImage
          src={user?.userImage || Images.NurseImage}
          alt="nurse image"
        />
        <p>My Profile</p>
      </NavLink>
    </Link>

    <NavLink $last={true} title="logout">
      <Logout onClick={logout}>Logout</Logout>
    </NavLink>
  </>
);

const MenuIconComp = ({ toggleNavbar }) => (
  <MenuIcon onClick={toggleNavbar}>
    <div className="bar one"></div>
    <div className="bar two"></div>
    <div className="bar three"></div>
  </MenuIcon>
);

const Nav = tw.nav`z-40 bg-white w-full border-b navbar fixed top-0 right-0 left-0`;

const MenuIcon = tw.div`cursor-pointer z-10 md:hidden`;

const Container = tw.div` 
Container flex items-center justify-between`;

const Logo = tw.img`w-12 z-10 h-14`;
const VerticalBorder = tw.div`w-2.5 h-12 bg-gray-300 mt-1`;

const NavLinksWrapper = tw.ul`
${(p) => (p.$isNavActive ? "translate-y-0" : "-translate-y-full")}
fixed  shadow-md top-0 right-0 left-0 flex flex-col bg-white pt-20 transition duration-200 pb-5  md:relative  md:translate-y-0 md:shadow-none md:flex-row   md:bg-transparent md:p-0   md:items-center w-full md:justify-end md:h-full`;

// const NavLink = tw.li`
// ${(p) => (p.$last ? "" : "border-b")}
// text-sm text-gray-500 hover:text-gray-800 relative hover:bg-gray-100 flex space-x-1.5 items-center cursor-pointer w-full   py-3 nav-links-padding  md:hover:bg-transparent md:p-0 md:bg-tranparent  md:border-transparent  md:border-b-2 hover:border-gray-400  whitespace-nowrap md:w-auto md:h-full `;

const NavLink = tw.li` 
${(p) => (p.$active ? "md:bg-gray-100 text-gray-900" : "")}
text-sm text-gray-500  hover:text-gray-900 relative flex space-x-1.5 items-center cursor-pointer w-full   py-3    px-4 h-9 rounded-full hover:bg-gray-100  whitespace-nowrap md:w-auto md:h-full ml-1 `;

const NavLinkDropdown = tw.li` 
${(p) => (p.$active ? "md:bg-gray-100 text-gray-900" : "")}
text-sm text-gray-500  hover:text-gray-900 relative flex space-x-1.5 items-center cursor-pointer w-full   py-3    px-4 h-9 rounded-full whitespace-nowrap md:w-auto md:h-full ml-1 `;

const UserImage = tw.img`
w-6 h-6  md:w-8 md:h-8 rounded-full object-cover overflow-hidden bg-gray-100
`;

const Logout = tw.p` 
text-red-500 text-sm cursor-pointer`;

const SubLinksWrapper = tw.div`flex flex-col absolute bottom-0 bg-white p-2 py-3 text-sm  rounded-md border border-gray-200 shadow-md z-10 transform  translate-y-full  -translate-x-4`;

const SubLinksWrapper2 = tw.div`flex flex-col absolute bottom-0 bg-white p-2 py-3 text-sm  rounded-md border border-gray-200 shadow-md z-10 transform translate-y-full -translate-x-0 w-36`;
const HelpIcon = tw(FaQuestionCircle)`
  text-blue-500 text-xl cursor-pointer
`;

const HelpPopup = ({ onClose }) => (
  <div>
    <p>Email: example@example.com</p>
    <p>Phone: +1 234 567 890</p>
    <button onClick={onClose}>Close</button>
  </div>
);
export default Navbar;
